import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarRateIcon from "@mui/icons-material/StarRate";
import "./Rating.css";

type Props = {
  rating_star: number;
  rating_count: number;
  isRetailer: boolean;
};

const StyledRating = styled(Rating)({
  "& .MuiRating-icon": {
    color: "#0f0e96",
    "& .MuiSvgIcon-root": {
      height: "10px",
      width: "10px",
      fontSize: "12px",
    },
  },
  "& .MuiRating-iconFilled": {
    color: "#0f0e96",
  },
  "& .MuiRating-iconHover": {
    color: "rgba(27, 15, 143, 1)",
  },
});

const CustomizedRating: React.FC<Props> = (props) => {
  const [value, setValue] = React.useState<number>(props.rating_star);
  React.useEffect(() => {
    const rating = parseFloat(props?.rating_star.toFixed(1));
    setValue(rating);
  }, [props]);

  React.useEffect(() => {}, [value]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography align="center" className="product-rating">
        {value}
        <StyledRating
          readOnly
          name="customized-color"
          defaultValue={value}
          getLabelText={(value: number) =>
            `${value} star${value !== 1 ? "s" : ""}`
          }
          precision={0.5}
          icon={
            <StarRateIcon
              fontSize="large"
              sx={{ width: "10px", height: "10px" }}
            />
          }
          emptyIcon={
            <StarBorderIcon
              fontSize="small"
              sx={{ width: "10px", height: "10px" }}
            />
          }
          sx={{ paddingLeft: 0.5 }}
        />
        <span className="product-rating_count" style={{ paddingLeft: 10 }}>
          ({props?.rating_count.toLocaleString()})
        </span>
      </Typography>
    </Box>
  );
};

export default CustomizedRating;
